/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface LinkVmcSpec { 
    approve_linking?: boolean;
    preferred_vmc_org_id?: string;
    service_type: ServiceTypeEnum;
}
export namespace LinkVmcSpec {
}


